import { Box, Typography, Card, Stack, ListItem, ListItemAvatar, Avatar, ListItemText, Table, TableBody, TableRow, TableCell, IconButton, Tooltip } from "@mui/material";
import { getFirestore, getDoc, doc } from "firebase/firestore";
import { DateTime } from "luxon";
import { useState, useEffect } from "react";
import passportRequestConverter from "../../converters/passportRequestConverter";
import { Employee } from "../../types/Employee";
import { PassportRequest, PassportRequestStatus } from "../../types/PassportRequest";
import { queryEmployee } from "../../utils/queryEmployee";
import { Notification } from "../../types/Notification";
import { EnhancedTableCell } from "../EnhancedTableCell";
import { RunCircleRounded, MopedRounded, CheckCircleRounded } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import { MedicalPaperRequest } from "../../types/MedicalPaperRequest";
import medicalPaperRequestConverter from "../../converters/medicalPaperRequestConverter";
import { NotificationEmployeeHeading } from "./NotificationEmployeeHeading";
import { updateMedicalPaperRequestStatus } from "../../utils/updateMedicalPaperRequest";
import { MedicalPaperRequestInfoBox } from "../dashboard/medical/MedicalPaperRequestInfoBox";
import { RequestActionBox } from "../RequestActionBox";
import { UmrahPaperRequest, UmrahPaperRequestStatus } from "../../types/UmrahPaperRequest";
import { updateUmrahPaperRequestStatus } from "../../utils/updateUmrahPaperRequest";
import umrahPaperRequestConverter from "../../converters/umrahPaperRequestConverter";
import { UmrahPaperRequestInfoBox } from "../dashboard/umrah/UmrahPaperRequestInfoBox";

export const NotificationUmrahPaperRequest = (props: { notification: Notification }) => {
  const { notification } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [umrahPaperRequest, setUmrahPaperRequest] = useState<UmrahPaperRequest>();
  const [employee, setEmployee] = useState<Employee>();

  const db = getFirestore();

  const handleUpdateUmrahPaperRequest = (s: UmrahPaperRequestStatus) => {
    if (umrahPaperRequest) {
      setUpdating(true);
      updateUmrahPaperRequestStatus(umrahPaperRequest, s).then(() => {
        let message = `Employee '${umrahPaperRequest.idNumber}' umrah paper request has been update.`;
        if (s === 'Processing')
          message = `Employee '${umrahPaperRequest.idNumber}' umrah paper request is now being processed.`;
        else if (s === 'Available')
          message = `Employee '${umrahPaperRequest.idNumber}' umrah paper request is now ready for pickup.`;
        else if (s === 'Completed')
          message = `Employee '${umrahPaperRequest.idNumber}' umrah paper request is now tagged as complete.`;
        else if (s === 'Cancelled')
          message = `Employee '${umrahPaperRequest.idNumber}' umrah paper request is now cancelled.`;

        setUmrahPaperRequest({ ...umrahPaperRequest, status: s });
        enqueueSnackbar(message, { variant: 'success' });

        setUpdating(false);
      })
    }
  };

  useEffect(() => {
    if (umrahPaperRequest?.idNumber !== employee?.idNumber) {
      setLoading(true);
      if (umrahPaperRequest !== undefined) {
        queryEmployee(umrahPaperRequest.idNumber).then(e => {
          setEmployee(e);
          setLoading(false);
        });
      }
    }
  }, [umrahPaperRequest]);
  
  useEffect(() => {
    // Get passport request
    if (notification.pathToDocument) {
      getDoc(doc(db, notification.pathToDocument).withConverter(umrahPaperRequestConverter)).then(qDocSnapshot => {
        if (qDocSnapshot.exists()) {
          setUmrahPaperRequest(qDocSnapshot.data());
        }
      });
    }
  }, []);

  return (
    <Box>
      <Typography variant='h4' mb={1}>Umrah Paper Request</Typography>
      <Card>
        {loading ? (
          <Box p={1}>
            <Typography>Please wait...</Typography>
          </Box>
        ) : (
          <Box p={1}>
            <Stack direction='row' mb={2}>
              {employee && <NotificationEmployeeHeading employee={employee} />}
              {umrahPaperRequest && (<RequestActionBox status={umrahPaperRequest.status} onUpdateStatus={handleUpdateUmrahPaperRequest} isUpdating={updating} />)}
            </Stack>
            {umrahPaperRequest && (
              <UmrahPaperRequestInfoBox umrahPaperRequest={umrahPaperRequest} />
            )}
          </Box>
        )}
      </Card>
    </Box>
  );
};